import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CompanyInfoState } from './company-info.models';

export const selectCompanyState = createFeatureSelector<CompanyInfoState>('companyInfo');

export const selectCompanyByGuid = (companyGuid: string) =>
  createSelector(selectCompanyState, (state) => {
    const key = companyGuid?.toLowerCase?.();
    return state?.company?.[key] || null;
  });

export const selectCompany = createSelector(selectCompanyState, (state) => state.company);

export const selectCompanyLoading = createSelector(selectCompanyState, (state) => state.loading);

export const selectCompanyError = createSelector(selectCompanyState, (state) => state.error);
